"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("./context");
var useArrayList_1 = require("./hooks/useArrayList");
var useComponent_1 = require("./hooks/useComponent");
exports.ArrayList = function (props) {
    return (react_1.default.createElement(context_1.ArrayContext.Provider, { value: props }, props.children));
};
var createButtonCls = function (props, hasText) {
    if (props === void 0) { props = {}; }
    return {
        className: (hasText ? 'has-text' : '') + " " + (props.className || '')
    };
};
exports.ArrayList.useArrayList = useArrayList_1.useArrayList;
exports.ArrayList.useComponent = useComponent_1.useComponent;
exports.ArrayList.Wrapper = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var WrapperComponent = exports.ArrayList.useComponent('Wrapper');
    return react_1.default.createElement(WrapperComponent, __assign({}, props), children);
};
exports.ArrayList.Item = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var ItemComponent = exports.ArrayList.useComponent('Item');
    return react_1.default.createElement(ItemComponent, __assign({}, props), children);
};
exports.ArrayList.Remove = function (_a) {
    var children = _a.children, component = _a.component, index = _a.index, props = __rest(_a, ["children", "component", "index"]);
    var _b = exports.ArrayList.useArrayList(index), allowRemove = _b.allowRemove, renderWith = _b.renderWith;
    var Button = exports.ArrayList.useComponent(component);
    var RemoveIcon = exports.ArrayList.useComponent('RemoveIcon');
    if (allowRemove) {
        return renderWith('renderRemove', function (text) { return (react_1.default.createElement(Button, __assign({}, props, createButtonCls(props, text)),
            react_1.default.createElement(RemoveIcon, null),
            text)); }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment);
};
exports.ArrayList.Remove.defaultProps = {
    component: 'CircleButton'
};
exports.ArrayList.Addition = function (_a) {
    var children = _a.children, component = _a.component, props = __rest(_a, ["children", "component"]);
    var _b = exports.ArrayList.useArrayList(), allowAddition = _b.allowAddition, renderWith = _b.renderWith;
    var Button = exports.ArrayList.useComponent(component);
    var AdditionIcon = exports.ArrayList.useComponent('AdditionIcon');
    if (allowAddition) {
        return renderWith('renderAddition', function (text) { return (react_1.default.createElement(Button, __assign({}, props, createButtonCls(props, text)),
            react_1.default.createElement(AdditionIcon, null),
            text)); }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment);
};
exports.ArrayList.Addition.defaultProps = {
    component: 'TextButton'
};
exports.ArrayList.MoveUp = function (_a) {
    var children = _a.children, component = _a.component, index = _a.index, props = __rest(_a, ["children", "component", "index"]);
    var _b = exports.ArrayList.useArrayList(index), allowMoveUp = _b.allowMoveUp, renderWith = _b.renderWith;
    var Button = exports.ArrayList.useComponent(component);
    var MoveUpIcon = exports.ArrayList.useComponent('MoveUpIcon');
    if (allowMoveUp) {
        return renderWith('renderMoveUp', function (text) { return (react_1.default.createElement(Button, __assign({}, props, createButtonCls(props, text)),
            react_1.default.createElement(MoveUpIcon, null),
            text)); }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment);
};
exports.ArrayList.MoveUp.defaultProps = {
    component: 'CircleButton'
};
exports.ArrayList.MoveDown = function (_a) {
    var children = _a.children, component = _a.component, index = _a.index, props = __rest(_a, ["children", "component", "index"]);
    var _b = exports.ArrayList.useArrayList(index), allowMoveDown = _b.allowMoveDown, renderWith = _b.renderWith;
    var Button = exports.ArrayList.useComponent(component);
    var MoveUpIcon = exports.ArrayList.useComponent('MoveDownIcon');
    if (allowMoveDown) {
        return renderWith('renderMoveDown', function (text) { return (react_1.default.createElement(Button, __assign({}, props, createButtonCls(props, text)),
            react_1.default.createElement(MoveUpIcon, null),
            text)); }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment);
};
exports.ArrayList.MoveDown.defaultProps = {
    component: 'CircleButton'
};
exports.ArrayList.Empty = function (_a) {
    var children = _a.children, component = _a.component, props = __rest(_a, ["children", "component"]);
    var _b = exports.ArrayList.useArrayList(), allowAddition = _b.allowAddition, isEmpty = _b.isEmpty, renderWith = _b.renderWith;
    var Button = exports.ArrayList.useComponent(component);
    var AdditionIcon = exports.ArrayList.useComponent('AdditionIcon');
    var addtion;
    if (allowAddition) {
        addtion = renderWith('renderAddition', function (text) { return (react_1.default.createElement(Button, __assign({}, props, createButtonCls(props, text)),
            react_1.default.createElement(AdditionIcon, null),
            text)); });
    }
    if (isEmpty) {
        return renderWith('renderEmpty', function (text) {
            return (react_1.default.createElement(react_1.Fragment, null,
                react_1.default.createElement("img", { style: { backgroundColor: 'transparent' }, src: '//img.alicdn.com/tfs/TB1cVncKAzoK1RjSZFlXXai4VXa-184-152.svg' }),
                text,
                addtion));
        }, children);
    }
    return react_1.default.createElement(react_1.default.Fragment);
};
exports.ArrayList.Empty.defaultProps = {
    component: 'TextButton'
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react-shared-components/lib/ArrayList.js
// module id = 4669
// module chunks = 0